import { Inline, Skeleton, Stack } from '@omnipresentgroup/design-system';

export const InputFieldSkeleton = ({
  withHelper,
}: {
  withHelper?: boolean;
}) => {
  return (
    <Stack gap="4">
      <Inline h={24} align="center">
        <Skeleton height={14} width={200} />
      </Inline>
      <Skeleton height={40} />
      {withHelper && <Skeleton height={14} width={300} />}
    </Stack>
  );
};
